var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.34,15.14h-10.29c-1.16,0-2.1,.94-2.1,2.1v30.85c0,1.16,.94,2.1,2.1,2.1s2.1-.94,2.1-2.1v-8.18h8.19c3.31,0,6.42-1.29,8.76-3.63,2.34-2.34,3.63-5.45,3.63-8.76s-1.29-6.42-3.63-8.76c-2.34-2.34-5.45-3.63-8.76-3.63Zm5.79,18.18c-1.55,1.55-3.6,2.4-5.79,2.4h-8.19V19.34h8.19c2.19,0,4.24,.85,5.79,2.4,1.55,1.55,2.4,3.6,2.4,5.79s-.85,4.25-2.4,5.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.74,3.06H9.26c-3.42,0-6.19,2.78-6.19,6.19V54.74c0,2.86,2.71,6.19,6.19,6.19H54.74c3.42,0,6.19-2.78,6.19-6.19V9.26c0-2.86-2.71-6.19-6.19-6.19Zm2,51.68c0,1.1-.9,2-2,2H9.26c-1.03,0-2-1.25-2-2V9.26c0-1.1,.9-2,2-2H54.74c1.03,0,2,1.25,2,2V54.74Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoParking);
export default __webpack_public_path__ + "static/media/pho_parking.0bb2f7465024f2ce37d434fed0d4a522.svg";
export { ForwardRef as ReactComponent };